import { useState } from "react";
// import Modal from 'react-bootstrap/Modal';

const NetworkModal = () => {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      {show ? (
        <div
          className="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center text-center p-4 min-h-full">
              <div className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                {/* <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"> */}
                <div className="bg-white p-10">
                  <div className="sm:flex sm:items-start">
                    {/* <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                  <AiOutlineCheck className="h-6 w-6 text-green-600" />
                </div> */}
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <h3
                        className="text-lg leading-6 font-medium text-red-900 font-bold"
                        id="modal-title"
                      >
                        Seems like your internet may be down!
                      </h3>
                      <div className="mt-4">
                        <p className="text-sm text-gray-500">
                          No network connection. Check your connection..
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-10 flex justify-center">
                    <button
                      onClick={() => handleClose()}
                      type="button"
                      className="flex justify-center compass_color font-bold cursor-pointer"
                    >
                      Continue Anyway
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default NetworkModal;
